import React from "react"

import { ProductConfiguratorStepType } from "shared/types/ProductConfiguration"

import { ProductConfiguratorProps } from "../../ProductConfigurator"
import { ProductConfiguratorConfiguration } from "../ProductConfiguratorConfiguration"
import { ProductConfiguratorAddons } from "../addons/ProductConfiguratorAddons"
import { ExternalProductDimensioning } from "../external-dimensioning/ExternalProductDimensioning"
import { ProductConfiguratorSummaryStep } from "./ProductConfiguratorSummaryStep"

export type ProductConfiguratorStepFactoryProps = Pick<
  ProductConfiguratorProps,
  | "externalProductDimensioningModel"
  | "externalDimensioningBaseProductCardComponent"
  | "addonOptions"
  | "onAddonDelete"
> & {
  activeStep: ProductConfiguratorStepType
}

export function ProductConfiguratorStepFactoryComponent({
  activeStep,
  externalProductDimensioningModel,
  externalDimensioningBaseProductCardComponent,
  addonOptions,
  onAddonDelete
}: ProductConfiguratorStepFactoryProps) {
  switch (activeStep) {
    case ProductConfiguratorStepType.DIMENSIONING: {
      return externalProductDimensioningModel ? (
        <ExternalProductDimensioning
          {...externalProductDimensioningModel}
          baseProductCardComponent={
            externalDimensioningBaseProductCardComponent
          }
        />
      ) : null
    }
    case ProductConfiguratorStepType.CONFIGURATION: {
      return <ProductConfiguratorConfiguration />
    }
    case ProductConfiguratorStepType.ADDONS: {
      return (
        <ProductConfiguratorAddons
          addonOptions={addonOptions}
          onAddonDelete={onAddonDelete}
        />
      )
    }
    case ProductConfiguratorStepType.SUMMARY:
      return <ProductConfiguratorSummaryStep />
    default:
      return null
  }
}

export const ProductConfiguratorStepFactory = React.memo(
  ProductConfiguratorStepFactoryComponent
) as typeof ProductConfiguratorStepFactoryComponent
